import { AUTH_TYPES, USER } from "../reducers/login";
import api from "../../service/api";
import { notify } from "react-notify-toast";

import payloadLoginInterface from "../interfaces/payloadLoginInterface"

export const fetchLogin = () => ({
  type: AUTH_TYPES.FETCH,
});

export const successLogin = (payload:payloadLoginInterface) => ({
  type: AUTH_TYPES.SUCCESS,
  payload,
});

export const failLogin = () => ({
  type: AUTH_TYPES.FAIL,
});

export const resetLogin = () => ({
  type: AUTH_TYPES.RESET,
});

export const login = (credentials: { email: string, password: string}) => {
  return async (dispatch : Function) => {
    try {
      dispatch(fetchLogin());

      const response = await api.post(
        "/login",
        JSON.stringify(credentials)
      );
      
      const payload = {
        user: response.data.user,
        token: response.data.token,
        planVenda: response.data.planVenda,
        authorized: true
      };

      dispatch(successLogin(payload));
    } catch (error) {
      notify.show(
        "Verifique seu email e senha se estão corretos",
        "error",
        2500
      );
      dispatch(failLogin());
    }
  };
};

export const changeUser = (user: any) => ({
  type: USER.CHANGE,
  payload: {
    user
  }
});